export default __webpack_public_path__ + "static/foto-savasa-74d48928ad6a0131c97aedfd46341035.jpg";